module.exports = __webpack_public_path__ + "img/p36.27fcada6.png";